import { render, staticRenderFns } from "./Courses.vue?vue&type=template&id=b981fd12&"
import script from "./Courses.js?vue&type=script&lang=js&"
export * from "./Courses.js?vue&type=script&lang=js&"
import style0 from "./Courses.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports